import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {RestaurantStatisticsService} from "../../../services/wrapper/restaurant-statistics.service";
import {Constants} from "../../../utils/constants";
import {MyStorageService} from "../../../services/common/my-storage.service";

@Component({
    selector: 'comp-restaurant-statistics',
    templateUrl: './restaurant-statistics.component.html',
    styleUrls: ['./restaurant-statistics.component.scss']
})
export class RestaurantStatisticsComponent implements OnInit, OnChanges {
    public canvas: any;
    public ctx;
    @Input() restaurants: any[] = [];

    public selectedRestaurantId: number;
    public selectedRestaurantHistoryId: number;
    public selectedRestaurantHistorySlug: string;

    statistics: any;

    date: Date = new Date();
    private storedRestaurantHistoryId: number;

    constructor(private service: RestaurantStatisticsService, private myStorageService:MyStorageService) {
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.restaurants.length > 0) {
            this.storedRestaurantHistoryId = this.myStorageService.getFromCookies(Constants.RESERVATION_RESTAURANT_HISTORY_ID_KEY, this.restaurants[0].historyId);
            const restaurant = this.restaurants.find(rest => rest.historyId == this.storedRestaurantHistoryId);
            this.changeRestaurant(restaurant);
        }
    }

    private loadData() {
        this.service.getStatisticForRestaurant(this.selectedRestaurantHistoryId, this.date).subscribe(result => {
            this.statistics = result;
        })
    }

    filter(date) {
        this.date = date;
        this.loadData();
    }

    changeRestaurant(restaurant) {
        this.selectedRestaurantId = restaurant.id;
        this.selectedRestaurantHistoryId = restaurant.historyId;
        this.selectedRestaurantHistorySlug = restaurant.historySlug;
        this.loadData();
    }


    toDate(start: any) {
        return new Date(start);
    }

}
